export default __webpack_public_path__ + "static/media/pushup.a4ab0edb.png";